'use client';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import BaseSection from '@repo/ui/src/components/Section';
import { warm } from '@style/variables';
import isPropValid from '@emotion/is-prop-valid';

export const Section = styled(BaseSection)<{ isCategory: boolean }>(({ isCategory }) => ({
  backgroundColor: `${isCategory ? warm[100] : warm[200]} !important`,
}));

export const ImageWrapper = styled(Box)(`
  position: relative;
  height: 0;
  width: 100%;
  padding-top: 83%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("https://traegergrills.a.bigcontent.io/v1/static/log-background");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0;
    transition: opacity 500ms ease;
  }

  & img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`);

export const Grid = styled('div', { shouldForwardProp: isPropValid })<{ isCategory: boolean }>(
  ({ theme, isCategory }) => `
      display: grid;
      grid-gap: 1rem;
      text-align: center;
      margin-top: 40px;

      ${theme.breakpoints.down('md')} {
        grid-template-columns:
          ${
            isCategory
              ? 'repeat(auto-fill, minmax(100%, 1fr))'
              : 'repeat(auto-fill, minmax(calc(50% - 1rem), 1fr))'
          };
      }

      ${theme.breakpoints.up('sm')} {
        grid-template-columns: repeat(auto-fill, minmax(calc(50% - 1rem), 1fr));
      }

      ${theme.breakpoints.up('lg')} {
        grid-gap: 2rem;
        grid-template-columns: repeat(auto-fill, minmax(calc(25% - 2rem), 1fr));
        margin-top: 80px;
      }
  `,
);

export const ByCategoryBox = styled(Box)(
  ({ theme }) => `
    ${theme.breakpoints.down('md')}: {
      width: 80%;
      margin: 0 auto 1rem;
    }

    &:hover .image-wrapper:before {
      opacity: 1;
    }
  `,
);

export const ByPriceBox = styled(Box)(
  ({ theme }) => `
    height: 0;
    position: relative;
    width: 100%;
    padding-top: 100%;
    border: 4px solid ${theme.palette.primary.main};
    transition: background 500ms ease;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("https://traegergrills.a.bigcontent.io/v1/static/log-background-orange");
      background-size: cover;
      opacity: 0;
      transition: opacity 500ms ease;
    }

    &:hover {
      & > div span,
      & > div h3 {
        color: white;
      }

      &:before {
        opacity: 1;
      }
    }
  `,
);

export const TextBox = styled(Box)(`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
`);

export const CurrencySymbol = styled('span')(
  ({ theme }) => `
    font-size: 42px;
    vertical-align: super;
    line-height: 1;

    ${theme.breakpoints.up('sm')} {
      font-size: 96px;
    }
  `,
);

export const Price = styled('span')(
  ({ theme }) => `
    font-size: 80px;
    line-height: 1;

    ${theme.breakpoints.up('sm')} {
      font-size: 168px;
    }
  `,
);
